import { scrollToTop } from "@/utils";
import {
  FileText,
  Heart,
  HelpCircle,
  Mail,
  MapPin,
  Newspaper,
  Phone,
  Shield,
} from "lucide-react";
import { Link } from "react-router-dom";
import CopyRightSocial from "./CopyRightSocial";

const Footer = () => {
  return (
    <footer className="bg-slate-950 text-white border-t border-slate-900">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-8 sm:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {/* Column 1: Church Identity & Address */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <img
                src="/favicon.ico"
                width={22}
                height={22}
                alt="Logo Garizim"
                className="shrink-0"
              />
              <div className="text-base sm:text-lg font-bold tracking-tight">
                ÉGLISE DE DIEU GARIZIM
              </div>
            </div>

            <p className="text-xs text-slate-400 leading-relaxed">
              Une assemblée chrétienne évangélique dédiée à l'enseignement
              biblique, à la communion fraternelle et à la louange à Montréal et
              sur la Rive-Sud depuis 1977.
            </p>

            <div className="flex items-start gap-3 pt-1">
              <div className="bg-church-gold-500 p-2 rounded-lg shrink-0 mt-0.5">
                <MapPin className="w-4 h-4 text-black" />
              </div>
              <div>
                <div className="text-[11px] font-bold text-church-gold-400 uppercase tracking-wider">
                  SANCTUAIRE MONTRÉAL
                </div>
                <address className="text-xs text-gray-300 not-italic leading-relaxed">
                  11800 4e Avenue, Montréal, QC H1E 5Y2
                </address>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="bg-church-gold-500 p-2 rounded-lg shrink-0 mt-0.5">
                <MapPin className="w-4 h-4 text-black" />
              </div>
              <div>
                <div className="text-[11px] font-bold text-church-gold-400 uppercase tracking-wider">
                  CAMPUS RIVE-SUD
                </div>
                <address className="text-xs text-gray-300 not-italic leading-relaxed">
                  2600 Rue Grant, Longueuil, QC J4L 3W6
                </address>
              </div>
            </div>
          </div>

          {/* Column 2: Navigation Principale */}
          <div>
            <h3 className="text-sm sm:text-base font-bold mb-3 sm:mb-4 text-church-gold-400 uppercase tracking-wider">
              NAVIGATION
            </h3>
            <ul className="space-y-2 text-xs sm:text-sm">
              <li>
                <Link
                  to="/"
                  className="text-gray-300 hover:text-white transition-colors block"
                  onClick={() => scrollToTop()}
                >
                  Accueil (Montréal)
                </Link>
              </li>
              <li>
                <Link
                  to="/garizim-rive-sud"
                  className="text-gray-300 hover:text-white transition-colors block"
                  onClick={() => scrollToTop()}
                >
                  Campus Rive-Sud
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-gray-300 hover:text-white transition-colors block"
                  onClick={() => scrollToTop()}
                >
                  Horaires des Cultes
                </Link>
              </li>
              <li>
                <Link
                  to="/chants-desperance"
                  className="text-gray-300 hover:text-white transition-colors block"
                  onClick={() => scrollToTop()}
                >
                  Chants d'Espérance
                </Link>
              </li>
              <li>
                <Link
                  to="/articles"
                  className="text-gray-300 hover:text-white transition-colors block font-semibold text-amber-300 hover:text-amber-200"
                  onClick={() => scrollToTop()}
                >
                  Articles & Réflexions
                </Link>
              </li>
              <li>
                <Link
                  to="/events"
                  className="text-gray-300 hover:text-white transition-colors block"
                  onClick={() => scrollToTop()}
                >
                  Évènements & Galerie
                </Link>
              </li>
              <li>
                <Link
                  to="/archives"
                  className="text-gray-300 hover:text-white transition-colors block"
                  onClick={() => scrollToTop()}
                >
                  Archives Vidéos
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Transparence & Légal (Google AdSense requirement) */}
          <div>
            <h3 className="text-sm sm:text-base font-bold mb-3 sm:mb-4 text-church-gold-400 uppercase tracking-wider">
              LÉGAL & TRANSPARENCE
            </h3>
            <ul className="space-y-2 text-xs sm:text-sm">
              <li>
                <Link
                  to="/a-propos"
                  className="text-gray-300 hover:text-white transition-colors block"
                  onClick={() => scrollToTop()}
                >
                  À Propos de Garizim
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-gray-300 hover:text-white transition-colors block"
                  onClick={() => scrollToTop()}
                >
                  Nous Contacter
                </Link>
              </li>
              <li>
                <Link
                  to="/politique-de-confidentialite"
                  className="text-gray-300 hover:text-white transition-colors block font-medium"
                  onClick={() => scrollToTop()}
                >
                  Politique de Confidentialité
                </Link>
              </li>
              <li>
                <Link
                  to="/conditions-utilisation"
                  className="text-gray-300 hover:text-white transition-colors block font-medium"
                  onClick={() => scrollToTop()}
                >
                  Conditions d'Utilisation
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy-policy-2"
                  className="text-gray-400 hover:text-white transition-colors block text-[11px]"
                  onClick={() => scrollToTop()}
                >
                  Privacy Disclosures (AdSense)
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Contact direct */}
          <div className="space-y-4">
            <h3 className="text-sm sm:text-base font-bold text-church-gold-400 uppercase tracking-wider">
              CONTACT & ÉCOUTE
            </h3>

            {/* Courriel */}
            <div className="flex items-start gap-3">
              <div className="bg-church-gold-500 p-2 rounded-lg shrink-0 mt-0.5">
                <Mail className="w-4 h-4 text-black" />
              </div>
              <div>
                <div className="text-[11px] font-bold text-church-gold-400 uppercase tracking-wider">
                  COURRIEL
                </div>
                <a
                  href="mailto:egarizim@gmail.com"
                  className="text-xs sm:text-sm text-gray-300 hover:text-white transition-colors block"
                >
                  egarizim@gmail.com
                </a>
                <Link
                  to="/contact"
                  onClick={() => scrollToTop()}
                  className="text-xs text-church-gold-400 hover:text-white underline mt-1 block"
                >
                  Formulaire de contact &rarr;
                </Link>
              </div>
            </div>

            {/* Téléphone */}
            <div className="flex items-start gap-3">
              <div className="bg-church-gold-500 p-2 rounded-lg shrink-0 mt-0.5">
                <Phone className="w-4 h-4 text-black" />
              </div>
              <div>
                <div className="text-[11px] font-bold text-church-gold-400 uppercase tracking-wider">
                  TÉLÉPHONE
                </div>
                <a
                  href="tel:5143224921"
                  className="text-xs sm:text-sm text-gray-300 hover:text-white transition-colors font-mono block"
                >
                  (514) 322-4921
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CopyRightSocial />
    </footer>
  );
};

export default Footer;
